<template>
  <div>
    <h2>{{hasRecord}}异常记录</h2>
    <Spin fix v-show="isSpinShow">
      <Icon type="ios-loading" size="18" class="spin-icon-load"></Icon>
      <div>Loading</div>
    </Spin>
    <Card :bordered="false">
      <p>{{address + " " + requestBody.meterId}}</p>
    </Card>
    <Scroll :height="height * 0.75" :on-reach-bottom="handleReachEdge" :distance-to-edge="[100,1]">
      <Collapse class="collapse" accordion>
        <Panel v-for="(valueitem, index) in records" class="panel">
          <span v-if="valueitem.occurType == '触发'" style="color:#ed4014">{{"【" + valueitem.occurType + "】"}}</span>
          <span v-if="valueitem.occurType == '解除'" style="color:#19be6b">{{"【" + valueitem.occurType + "】"}}</span>
          {{valueitem.abnormalName}}
          <template slot="content">
            <p style="padding-left:20px">{{"【发生日期:" + valueitem.occurTime + "】"}}</p>
            <p style="padding-left:20px" v-for="(abitem, index) in valueitem.abArray">{{abitem}}</p>
          </template>
        </Panel>
      </Collapse>
      <p>上滑加载</p>
    </Scroll>
  </div>
</template>
<script>
export default {
  mounted() {},
  data() {
    return {
      address: "",
      hasRecord: "",
      requestBody: {},
      height: document.body.clientHeight,
      width: document.body.clientWidth,
      list3: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
      dailyRecord: [],
      dailyRecordColumns: [],
      records: [],
      formatObject: {},
      pageSize: 40,
      pageNo: 1,
      isSpinShow: false
    };
  },
  methods: {
    clearData() {
      this.recordColumns = [];
      this.records = [];
      this.formatObject = {};
      this.pageNo = 1;
    },
    getAbnormalRecord() {
      this.isSpinShow = true;
      var that = this;
      that.hasRecord = "";
      $.ajax({
        url: "/api/getAbnormalDetailed",
        contentType: "application/json",
        type: "post",
        data: JSON.stringify({
          page: that.pageNo,
          amount: that.pageSize,
          conditions: that.requestBody
        }),
        dataType: "json",
        success: function(data) {
          console.log(data.body.list);
          if (data.errorCode != 0) {
            that.$Notice.error({
              title: "异常",
              desc: data.errorInfo
            });
            return;
          }

          if (data.body.list.length == 0) {
            if (that.records.length == 0) {
              that.hasRecord = "暂无";
            }
            return;
          } else {
            if (data.body.list.length > 0) {
              that.address = data.body.list[0].completeAddress;
            }
            data.body.list.forEach(function(value, i) {
              let abArray = value.abnormalField.split("\n");
              value["abArray"] = abArray;
              that.records.push(value);
            });
          }
        },
        error: function(textStatus) {
          that.loading = false;
          that.$Notice.error({
            title: "异常",
            desc: "接口请求异常"
          });
        },
        complete: function(XMLHttpRequest, textStatus) {
          that.isSpinShow = false;
        }
      });
    },
    handleReachEdge(dir) {
      return new Promise(resolve => {
        if (dir > 0) {
        } else {
          this.pageNo = this.pageNo + 1;
          this.getAbnormalRecord();
        }
        resolve();
      });
    }
  }
};
</script>
<style scope>
.collapse {
  margin: 5px;
  background-color: white;
  text-align: left;
  font-size: 16px;
}

.panel {
  font-weight: 800;
  font-family: "SimSun";
  font-size: 16px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.row {
  margin: 5px;
}
.ivu-collapse-content {
  padding: 0;
}
</style>

